import { createContext, useContext, useId, type ReactNode } from "react";
import { cn } from "./cn";

type FieldCtx = { id: string; describedBy?: string; invalid: boolean };

const FieldContext = createContext<FieldCtx | null>(null);

export function useField() {
  return useContext(FieldContext);
}

export type FieldProps = {
  label: ReactNode;
  error?: ReactNode;
  className?: string;
  children: ReactNode;
};

export function Field({ label, error, className, children }: FieldProps) {
  const id = useId();
  const describedBy = error ? `${id}-error` : undefined;
  return (
    <FieldContext.Provider value={{ id, describedBy, invalid: Boolean(error) }}>
      <div className={cn("flex flex-col gap-1.5", className)}>
        <label htmlFor={id} className="text-[13px] font-semibold text-ink">
          {label}
        </label>
        {children}
        {error ? (
          <p id={describedBy} className="text-[13px] text-bad-ink" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </FieldContext.Provider>
  );
}
